import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Popover,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ContainerDrawer } from "./basic/container-drawer";
import { AppSingleton } from "./services/user_config";

const App = () => {
  var appSingleton = new AppSingleton();
  const [notifications, setNotifications] = useState([]);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  appSingleton.windowSize = windowSize;
  appSingleton.notifications = notifications;
  appSingleton.setNotifications = setNotifications;

  useEffect(() => {
    document.body.style.overflow = "hidden";
    // document.body.classList.add("no-scroll")

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    if (notifications.length > 0) {
      console.log("!!! new event detected");
      console.log(notifications);
      const toastConfig = {
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
      };
      notifications.forEach((_notification) => {
        switch (_notification?.type) {
          case "error":
            toast.error(_notification.data, toastConfig);
            break;
          default:
            toast.info(_notification.data, toastConfig);
        }
      });
      setNotifications([]);
    }
  }, [notifications]);

  return (
    <Box>
      <AppBar>
        <Toolbar
          disableGutters
          sx={{
            background: "#2E3B55",
            // justifyContent: "space-between",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              variant="h6"
              color="inherit"
              component="div"
              noWrap
              sx={{
                ml: 2,
                mr: 2,
              }}
              onClick={() => {
                appSingleton?.navigate("/");
              }}
            >
              NAAC x Reality Connect Technology
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ContainerDrawer />
      </BrowserRouter>

      {/* <Box sx={{ display: "flex" }}>
        <CssBaseline />
      </Box> */}
      <ToastContainer />
    </Box>
  );
};
export default App;
